import React from 'react';
import { Trans, t } from '@lingui/macro';
import Slice from 'components/Slice/Slice';
import {
    Heading,
    Text,
    GuitarOutlined,
    MusicNote,
    SunOutlined,
    ListMusicNoteOutlined,
    Flex,
    spacing,
} from '@landr/maestro';
import { RoutePaths } from 'types/enums';
import styled from 'styled-components';
import {
    FiltersTabs,
    useSidebarLayoutContext,
} from 'controllers/SidebarLayout/SidebarLayout';
import { TrendingCard } from './components/TrendingCard';
import {
    trendingInstruments,
    trendingGenres,
    trendingBpmAndKeys,
    trendingSfxs,
} from './trendings';

const TrendingCardsContainer = styled(Flex)`
    gap: ${spacing('xl')};
    max-width: 100%;
    flex-wrap: wrap;
    margin-top: ${spacing('xxl')};

    ${({ theme }): string => theme.breakpoint('ms')`
        gap: ${spacing('sm')};
    `}
`;

export const TrendingSearches = () => {
    const { openSidebar, setDefaultSelectedTab } = useSidebarLayoutContext();

    return (
        <Slice>
            <Heading as="h2" size="xl" mb="4px">
                <Trans>Search Samples by Category</Trans>
            </Heading>
            <Text contrast="low">
                <Trans>
                    Navigate LANDR's sample library by genre, instrument, sound
                    effect, BPM or key
                </Trans>
            </Text>
            <TrendingCardsContainer>
                <TrendingCard
                    icon={GuitarOutlined}
                    title={t`Instruments`}
                    path={RoutePaths.Instruments}
                    trendings={trendingInstruments}
                />
                <TrendingCard
                    icon={MusicNote}
                    title={t`Genres`}
                    path={RoutePaths.Genres}
                    trendings={trendingGenres}
                />
                <TrendingCard
                    icon={SunOutlined}
                    title={t`SFX`}
                    path={RoutePaths.Sfxs}
                    trendings={trendingSfxs}
                />
                <TrendingCard
                    icon={ListMusicNoteOutlined}
                    title={t`BPM & Key`}
                    path={RoutePaths.Browse}
                    trendings={trendingBpmAndKeys}
                    onClick={() => {
                        openSidebar();
                        setDefaultSelectedTab(FiltersTabs.BpmAndKeys);
                    }}
                />
            </TrendingCardsContainer>
        </Slice>
    );
};
